$typography-heading-1-font-family: 'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';
$typography-heading-1-font-size: 2.25rem;
$typography-heading-1-font-weight: 800;
$typography-heading-1-line-height: 1.2;
$typography-heading-1-letter-spacing: -0.0125em;
$typography-heading-2-font-family: 'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';
$typography-heading-2-font-size: 1.5rem;
$typography-heading-2-font-weight: 700;
$typography-heading-2-line-height: 1.3333333;
$typography-heading-2-letter-spacing: 0em;
$typography-heading-3-font-family: 'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';
$typography-heading-3-font-size: 1.25rem;
$typography-heading-3-font-weight: 600;
$typography-heading-3-line-height: 1.6;
$typography-heading-3-letter-spacing: 0em;
$typography-heading-4-font-family: 'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';
$typography-heading-4-font-size: 1rem;
$typography-heading-4-font-weight: 600;
$typography-heading-4-line-height: 1.5;
$typography-heading-4-letter-spacing: 0em;
$typography-body-font-family: 'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';
$typography-body-font-size: 1rem;
$typography-body-font-weight: 400;
$typography-body-line-height: 1.75;
$typography-body-letter-spacing: 0em;
$typography-body-sm-font-family: 'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';
$typography-body-sm-font-size: 0.875rem;
$typography-body-sm-font-weight: 400;
$typography-body-sm-line-height: 1.75;
$typography-body-sm-letter-spacing: 0em;
$typography-lead-font-family: 'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';
$typography-lead-font-size: 1.25rem;
$typography-lead-font-weight: 400;
$typography-lead-line-height: 1.6;
$typography-lead-letter-spacing: 0em;
$typography-caption-font-family: 'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';
$typography-caption-font-size: 0.75rem;
$typography-caption-font-weight: 400;
$typography-caption-line-height: 1.5;
$typography-caption-letter-spacing: 0.025em;
$typography-code-font-family: 'JetBrains Mono', ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, 'Liberation Mono', monospace;
$typography-code-font-size: 0.875rem;
$typography-code-font-weight: 400;
$typography-code-line-height: 1.5;
$typography-code-letter-spacing: 0em;
